<template>
    <div class="page-home-content">
        <!-- 双新 -->
        <div class="main-content full-screen-container" v-if="doubleNew">
            <div class="main-container">
                <template v-for="item in doubleNewList" :key="item.modelKey">
                    <component
                        :is="item.component"
                        :model-title="item.title"
                        :double-new="true"
                    ></component>
                </template>
            </div>
        </div>
        <!-- 西城 -->
        <div
            v-else-if="['2', '4', '5'].includes(fromTemplateId)"
            class="main-content full-screen-container"
        >
            <div class="main-container">
                <XichengBanner :fromTemplateId="fromTemplateId" />
                <template v-for="item in list" :key="item.modelKey">
                    <component
                        :is="xComponentMap[item.modelKey]"
                        :model-title="item.modelTitle || item.modelName"
                        :fromTemplateId="fromTemplateId"
                        :tag-list="item.tagList || []"
                        :alias="item.alias"
                        :roleName="fromTemplateId == '4' ? '坊主' : '组长'"
                    ></component>
                </template>
            </div>
        </div>
        <!-- 通用 -->
        <div v-else-if="fromTemplateId">
            <CommonBanner />
            <template v-for="item in list" :key="item.modelKey">
                <component
                    :is="cComponentMap[item.modelKey]"
                    :model-title="item.modelTitle || item.modelName"
                    :fromTemplateId="fromTemplateId"
                    :alias="item.alias"
                    roleName="组长"
                ></component>
            </template>
        </div>
    </div>
</template>

<script setup>
import CommonBanner from './part/banner/common-index.vue';
import CommonNewsShortcut from './part/news-shortcut/common-index.vue';
import CommonGroupActivity from './part/group-activity/common-index.vue';
import CommonTraningActivity from './part/training-activity/common-index.vue';
import CommonTraningCourses from './part/training-courses/common-index.vue';
import CommonHotResources from './part/hot-resources/common-index.vue';
import CommonExcellentLesson from './part/excellent-lesson/common-index.vue';
import CommonOnlineCourse from './part/online-courses/common-index.vue';
import CommonWorkShop from './part/teacher-studio/common-index.vue';

import XichengBanner from './part/banner/index.vue';
import XichengNewsShortcut from './part/news-shortcut/index.vue';
import XichengStar from './part/research-star/index.vue';
import XichengGroupActivity from './part/group-activity/index.vue';
import XichengTraningActivity from './part/training-activity/index.vue';
import XichengTraningCourses from './part/training-courses/index.vue';
import XichengHotResources from './part/hot-resources/index.vue';
import XichengExcellentLesson from './part/excellent-lesson/index.vue';
import XichengOnlineCourse from './part/online-courses/index.vue';
import DoubleSchool from './part/double-school/index.vue';
import LiveHome from './part/live-home/index';
import WorkShopArticle from './part/workshop-article/index.vue';
import WorkShopAchievement from './part/workshop-achievement/index.vue';
import { onBeforeMount, ref, computed, provide, watch, shallowRef, inject } from 'vue';
import { pageJump } from '@/global/location-transfer';
import { useStore } from 'vuex';
const store = useStore();

const moocComName = inject('moocComName');

const props = defineProps({
    doubleNew: {
        type: Boolean, // 双新标示
        default: false,
    },
    fromTemplateId: {
        // 门户首页模板
        // 模板：2-西城 4-新疆 5-贵州
        type: [Number, String],
        default: '',
    },
    templateList: {
        // 模板
        type: Array,
        default: () => {
            return [];
        },
    },
    dtBrand: String,
});

// 全部备案信息
const brand = computed(() => {
    // console.log('brand====', JSON.stringify(store.state.brand))
    return store.state.brand?.publishBrand || {};
});

// 具体配置信息
const brandModulesV2 = computed(() => {
    // console.log('brandInfo====', JSON.stringify(brand.value?.brandConfig))
    return brand.value?.brandModulesV2 || {};
});

const portalTemplate = computed(() => {
    let portal = brandModulesV2.value.find(i => i.moduleKey == 'portal');
    let portalDefault = portal.children.find(i => i.moduleKey == 'portal:default');
    let portalTemplate = portalDefault.children.find(i => i.moduleKey == 'portal:default:template');
    return portalTemplate.moduleRuleList.find(i => i.checked);
});
provide('portalTemplate', portalTemplate);

const list = ref([]);

const cComponentMap = {
    home: CommonNewsShortcut, // 首屏
    'activity:square': CommonTraningActivity, // 活动
    'coopgroup:square': CommonGroupActivity, // 协作组
    'resourceApplication:square': CommonHotResources, // 热门资源
    'train:districtTrain:courseSquare': CommonTraningCourses, // 培训课程
    'video:square': CommonExcellentLesson, // 优秀课例 视频案例所有
    'moocApplication:home': CommonOnlineCourse, // 网络课程 慕课
    'workshop:square': CommonWorkShop, // 工作室
    'double:school': DoubleSchool, // 结对学校
    'live:home': LiveHome, // 直播风采
};

const xComponentMap = {
    home: XichengNewsShortcut, // 首屏
    'activity:square': XichengTraningActivity, // 活动
    'coopgroup:square': XichengGroupActivity, // 协作组
    'resourceApplication:square': XichengHotResources, // 热门资源
    yanxiu_star: XichengStar, // 研修之星
    'train:districtTrain:courseSquare': XichengTraningCourses, // 培训课程
    'video:square': XichengExcellentLesson, // 优秀课例 视频案例所有
    'moocApplication:home': XichengOnlineCourse, // 网络课程 慕课
    'workshop:square': CommonWorkShop, // 工作室
    'workshop:application:default:article': WorkShopArticle, // 工作室简报
    'workshop:application:default:achievement': WorkShopAchievement, // 工作室成果
};

const doubleNewList = ref([
    {
        title: '协作组',
        modelKey: 'coopgroup:square',
        component: shallowRef(XichengGroupActivity),
    },
    {
        title: '研修课程',
        modelKey: 'train:districtTrain:courseSquare',
        component: shallowRef(XichengTraningCourses),
    },
    {
        title: '研修活动',
        modelKey: 'activity:square',
        component: shallowRef(XichengTraningActivity),
    },
    {
        title: `西城${moocComName}`,
        modelKey: 'moocApplication:home',
        component: shallowRef(XichengOnlineCourse),
    },
    {
        title: '视频案例',
        modelKey: 'video:square',
        component: shallowRef(XichengExcellentLesson),
    },
    {
        title: '热门资源',
        modelKey: 'resourceApplication:square',
        component: shallowRef(XichengHotResources),
    },
]);

watch(
    () => props.templateList,
    val => {
        if (val?.length) {
            if (props.doubleNew) {
                doubleNewList.value.forEach((item, index) => {
                    let modelIndex = val.findIndex((m, i) => {
                        return item.modelKey === m.modelKey;
                    });
                    if (modelIndex == -1) {
                        doubleNewList.value.splice(index, 1);
                    }
                });
            } else {
                const componentMap = ['2', '4', '5'].includes(props.fromTemplateId)
                    ? xComponentMap
                    : cComponentMap;
                const resultList = val.slice();
                if (props.dtBrand === 'bjsslsjdbf') {
                    const targetHome = resultList.find(item => item.modelKey === 'home');
                    targetHome &&
                        (targetHome.alias = [
                            { modelName: 'news', name: '项目动态' },
                            { modelName: 'notice', name: '工作计划' },
                        ]);
                    resultList.push({ modelName: '结对学校', modelKey: 'double:school' });
                    resultList.push({ modelName: '直播风采', modelKey: 'live:home' });
                }
                list.value = resultList.filter(item => !!componentMap[item.modelKey]);
            }
        }
    },
);

function go(url) {
    pageJump(url, true);
}

onBeforeMount(() => {
    // 获取门户栏目
    // getNavContent();
});
</script>

<style lang="scss">
.page-home-content {
    color: #000000;
    font-size: 14px;
    background-color: #ffffff;
    .main-content {
        min-height: calc(100vh - 280px);
        margin-bottom: 70px;
    }
    .page-float {
        width: 70px;
        background: #ffffff;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        position: fixed;
        top: 50%;
        right: 20px;
        transform: translateY(-50%);
        li {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 14px;
            cursor: pointer;
            &:last-child {
                &::after {
                    content: '';
                    display: none;
                }
            }
            &::after {
                content: '';
                display: inline-block;
                width: 24px;
                height: 1px;
                background: #eff0f2;
            }
            &:hover {
                .name {
                    color: var(--srt-main-active-text-color);
                }
                .iconfont {
                    color: var(--srt-main-active-text-color);
                }
            }
        }
        .app {
            &:hover {
                .qr {
                    display: flex;
                }
            }
        }
        .name {
            font-size: 12px;
            margin-top: 4px;
            margin-bottom: 14px;
            color: var(--srt-main-text-color);
            width: 48px;
            text-align: center;
        }
        .iconfont {
            font-size: 24px;
            color: var(--srt-color-light-gray);
            font-weight: bold;
        }
        .logo {
            width: 24px;
            height: 24px;
            border-radius: 6px;
            object-fit: fill;
        }
        .qr {
            align-items: center;
            padding: 12px;
            width: 212px;
            height: 104px;
            background: #ffffff;
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);
            position: absolute;
            right: 76px;
            bottom: 0px;
            display: none;
            transition: all 0.2s;
        }
        .qr-img {
            width: 80px;
            height: 80px;
            margin-right: 10px;
        }
        .qr-name {
            color: var(--srt-main-text-color);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 98px;
            display: inline-block;
        }

        .qr-tip {
            font-size: 12px;
            color: var(--srt-color-light-gray);
            margin-top: 14px;
            display: inline-block;
        }
    }
    .common-module-page:last-child {
        padding-bottom: 60px;
    }
}
</style>
